import moment from 'moment'

const mixinFilters = {
  filters: {
    minutesFormatPipe: function (minutesQuantity) {
      const duration = moment.duration(minutesQuantity, 'minutes')
      const days = duration.days() ? `${duration.days()}d` : ''
      const hours = duration.hours() ? `${duration.hours()}h` : ''
      const minutes = duration.minutes() ? `${duration.minutes()}m` : ''
      return `${days} ${hours} ${minutes}`
    },
    amountFormatPipe: function (amount) {
      if (!amount) return
      const formattedAmount = amount.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        minimumIntegerDigits: 1,
        useGrouping: true,
      })
      return formattedAmount
    },
  },
}

export default mixinFilters
